import type { AccountSearch } from '@/models/clients/types';

const KEY = 'recent_clients';
const MAX = 3;

export function getRecentClients(): AccountSearch[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '[]');
  } catch {
    return [];
  }
}

export function addRecentClient(client: AccountSearch) {
  const list = getRecentClients().filter((recent) => recent.id_account !== client.id_account);
  list.unshift(client);
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
}
